import { render, staticRenderFns } from "./ApiListView.vue?vue&type=template&id=1b8ebe2f&scoped=true"
import script from "./ApiListView.vue?vue&type=script&lang=js"
export * from "./ApiListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ebe2f",
  null
  
)

export default component.exports